import { useNavigate } from "@tanstack/react-router";
import { api } from "../api.js";
import { useResource } from "../useResource.js";
import { List, type ListDetail } from "./List.js";
import { Failed, Loading } from "./Loading.js";

/**
 * One saved list, wired.
 *
 * `Edit rules` goes to the builder with this list loaded, which then SAVES OVER it — the opposite
 * of the playlist's Regenerate, and correct for the opposite reason. A list is a query, so editing
 * its rules changes what it is; a playlist is a snapshot, so regenerating makes a new one.
 */
export function ListScreen({ listId }: { listId: number }) {
  const navigate = useNavigate();
  const list = useResource(() => api.get<ListDetail>(`/api/lists/${listId}`), [listId]);

  if (list.error) return <Failed error={list.error} retry={list.reload} />;
  if (list.loading || !list.data) return <Loading what="the list" />;

  return (
    <List
      key={list.data.id}
      list={list.data}
      onEdit={() => void navigate({ to: "/lists", search: { edit: listId } })}
      onDelete={() => void api.del(`/api/lists/${listId}`).then(() => navigate({ to: "/lists", search: {} }))}
    />
  );
}
